import { SavedReportsCard } from "@/Features/SavedReports";
import { QaMetricsApi } from "../../../../api";

export const SavedReports = ({ reportInfo }) => (
  <SavedReportsCard
    reportInfo={reportInfo}
    saveReport={QaMetricsApi.saveQaEntriesReport}
  />
);

export default SavedReports;
